export enum MemberTransferDocumentTypeEnum {
    CERTIFICATE = "FAM_CERTMT",
    EXAM = "FAM_EXAMMT",
    CV = "FAM_CVMT"
}